import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PrintService } from '../print.service';
import {ObservablesService} from '../observables.service'
import { Subject } from "rxjs";
import { _ } from 'underscore';
import {ApiService} from '../api.service'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// export interface DialogData {
//   action:boolean;
//   message:any;
//   data:any;
// }
@Component({
  selector: 'app-slip-print',
  templateUrl: './slip-print.component.html',
  styleUrls: ['./slip-print.component.scss']
})
export class SlipPrintComponent implements OnInit {

  slipIds: string[];
  slipDetails: Promise<any>[];

  slipSubscribeVariable:any;
  slipObserver:any = new Subject<any>();
  productSubscribeVariable:any;
  productObserver:any = new Subject<any>();
  loggedUserInfo:any;
  slipData:any;
  itemData:any;
  gstAmount:number = 0;
  totalAmt:number = 0;
  totalWeight:number = 0;
  variableSubscribeVariable:any;
  variableObserver:any = new Subject<any>();
  preferences:any=[]
  constructor(route: ActivatedRoute,public dialog: MatDialog,private api:ApiService,private print: PrintService,private observables:ObservablesService) {
    this.slipIds = route.snapshot.params['slipIds']
      .split(',');
      // console.log("slip ids==",this.slipIds)

  }

  ngOnInit() {
    this.api.getLoggedUserInfo().then((res:any)=>{
      // console.log('logged user info=',res)
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        this.getPreferences()
        this.slipDetails = this.slipIds
            .map(id => this.getSlipDetails(id));
            Promise.all(this.slipDetails)
            .then(() => this.print.onDataReady());
      }
    })
  }

  getPreferences(){
    this.api.send("findDb",{
      table:"preferences",
      conditions:[{"business_id":this.loggedUserInfo.business_id}]
    }).then((res:any)=>{
      if(res.data.length > 0){
        this.preferences = res.data[0]
        // console.log("preferences==",this.preferences)
      }else{
        //create a preference
      }
    })
  }

  getTotalUnit(variables){
    // console.log("asdasd=",variables)
    if(variables !== undefined){

      return variables.reduce( ( accumulator, currentValue ) => {
        return accumulator * parseFloat(currentValue.unit_variable_value);
      }, 1);
    }
  }



  getSlipDetails(slip_id){

    return new Promise((resolve)=>{

      this.api.send("findDb",{
        fields:["S.*,P.*,S.id as master_slip_id,S.party_name as business_name, P.business_name as customer_business_name"],
        table:"master_slips as S",
        joins:[{
          type:"left",
          table:"parties as P",
          conditions:["P.id = S.party_id"]
        }],
        conditions:[{
          "S.id" :slip_id
        }]
      }).then((result:any)=>{
        // console.log("result=",result)

        if(result.data.length > 0){

          this.slipData = result.data[0];
          // console.log("this.slipdata==",this.slipData)
          if(this.slipData.direct_slip_status){
            this.totalAmt = this.totalAmt + this.slipData.total_amount
            resolve(true)
          }else{

            this.api.send("findDb",{
              table:"categories",
              conditions:[{slip_id:this.slipData.slip_id}]
            }).then((result1:any)=>{
              // console.log("category == ",result1.data)

              this.getData(result1.data).then((res:any)=>{

                // console.log("final data = ",res)

                this.itemData = res;
                // this.getWeightTotal()
                this.getGstAmount().then(()=>{
                  resolve(true)
                })
                // //this.getTotalAmt()
              })

            })
          }
          // setTimeout(() => resolve({status:true}), 1000)
        }else{
          resolve({status:true})
        }
      })
    })

  }

  getData(data){
    return new Promise((resolve)=>{
      let a = 0
      let number = 0
      this.productSubscribeVariable = this.productObserver.subscribe((a)=>{
        if(a>=data.length){
          this.productSubscribeVariable.unsubscribe();
          resolve(data)
        }else{
          if(data[a].hasOwnProperty('category_name')){

            this.api.send("findDb",{
              table:"master_slip_products as PD",
              conditions:[{
                "PD.master_slip_id" :this.slipData.master_slip_id,
                "PD.category_id":data[a].id
              }],
              order:"PD.id ASC"
            }).then((result2:any)=>{
              // console.log("product data=",result2.data)
              if(result2.data.length > 0){
                this.prepareData(result2.data,a,data,number).then((resp:any)=>{
                  data=resp.data;
                  number=resp.number
                  this.productObserver.next(a+1);
                })

              }else{
                this.productObserver.next(a+1);
              }
            })
          }else{
            this.productObserver.next(a+1);
          }

        }
      })

      this.productObserver.next(a);
    })
  }

  // getData(data){
  //   return new Promise((resolve)=>{
  //     let a = 0
  //     let number = 0
  //     this.productSubscribeVariable = this.productObserver.subscribe((a)=>{
  //       if(a>=data.length){
  //         this.productSubscribeVariable.unsubscribe();
  //         resolve(data)
  //       }else{
  //         if(data[a].hasOwnProperty('category_name')){
  //
  //           this.api.send("findDb",{
  //             fields:["PD.rate as product_rate,PD.*,PD.id as product_detail_id,I.name as item_name,I.gst,U.name as unit_name,I.discount"],
  //             table:"product_details as PD",
  //             joins:[{
  //               type:"left",
  //               table:"items as I",
  //               conditions:["I.id = PD.item_id"]
  //             },{
  //               type:"left",
  //               table:"units as U",
  //               conditions:["U.id = I.unit_id"]
  //             }],
  //             conditions:[{
  //               "PD.slip_id" :this.slipData.slip_id,
  //               "PD.category_id":data[a].id
  //             }],
  //             order:"PD.id ASC"
  //           }).then((result2:any)=>{
  //             // console.log("product data=",result2.data)
  //             if(result2.data.length > 0){
  //               this.prepareData(result2.data,a,data,number).then((resp:any)=>{
  //                 data=resp.data;
  //                 number=resp.number
  //                 this.productObserver.next(data.length+1);
  //               })
  //
  //             }else{
  //               this.productObserver.next(a+1);
  //             }
  //           })
  //         }else{
  //           this.productObserver.next(a+1);
  //         }
  //
  //       }
  //     })
  //
  //     this.productObserver.next(a);
  //   })
  // }
  // prepareData(item,index,data,number){
  //   return new Promise((resolve)=>{
  //     let a = 1
  //     this.variableSubscribeVariable = this.variableObserver.subscribe((a)=>{
  //       if(a>item.length){
  //         this.variableSubscribeVariable.unsubscribe();
  //         resolve({data:data,number:number})
  //       }else{
  //         number = number + 1;
  //         data.splice(index+a, 0, item[a-1]);
  //         data[index+a].number = number;
  //         data[index+a].unit_variables = []
  //           this.getProductUnitVariables(item[a-1]).then((itemRes:any)=>{
  //             data[index+a].unit_variables = itemRes
  //               this.variableObserver.next(a+1);
  //
  //           })
  //       }
  //
  //     })
  //
  //     this.variableObserver.next(a);
  //   })
  // }

  prepareData(item,index,data,number){
    return new Promise((resolve)=>{
      let a = 1
      this.variableSubscribeVariable = this.variableObserver.subscribe((a)=>{
        if(a>item.length){
          this.variableSubscribeVariable.unsubscribe();
          resolve({data:data,number:number})
        }else{
          number = number + 1;
          data.splice(index+a, 0, item[a-1]);
          data[index+a].number = number;
          // data[index+a].unit_variables = []
          this.variableObserver.next(a+1);
            // this.getProductUnitVariables(item[a-1]).then((itemRes:any)=>{
            //   data[index+a].unit_variables = itemRes
            //
            // })
        }

      })

      this.variableObserver.next(a);
    })
  }

  getProductUnitVariables(item){
    return new Promise((resolve)=>{
      this.api.send("findDb",{
        table:"product_unit_variables as PU",
        joins:[{
          type:"left",
          table:"unit_variables as UV",
          conditions:["UV.id = PU.unit_variable_id"]
        }],
        conditions:[{"PU.product_detail_id":item.product_detail_id}]
      }).then((res:any)=>{
        if(res.data.length > 0){

          resolve(res.data)
        }
      })
    })
  }



  async getGstAmount(){

    await this.itemData.filter((item:any)=>{
      if(!item.hasOwnProperty('slip_id')){

        this.gstAmount=this.gstAmount + ((item.gross_amount*item.gst)/100);
        this.totalAmt=this.totalAmt + item.gross_amount;
      }
    })

  }

}
